module.exports = __webpack_public_path__ + "71f7263c5b544d1619f81f0dd8c70285.pdf";